<template>
	<div class="information">
		<el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;">
			<el-col :span="5">
				<el-form-item label="店铺" prop="sellerId">
					<el-select v-model="ruleForm.sellerId" clearable filterable placeholder="请选择">
						<el-option v-for="item in spList" :key="item.sellerId" :label="item.shop_name"
							:value="item.sellerId"></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="5">
				<el-form-item label="拉取日期" prop="pullDate">
					<el-date-picker v-model="ruleForm.pullDate" type="date" clearable placeholder="请选择日期"
						:default-value="defaultDate" format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
			</el-col>

			<el-col :span="5">
				<el-form-item class="search">
					<el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
					<el-button type="primary" @click="resetFprm">重置</el-button>
				</el-form-item>
			</el-col>
		</el-form>

		<el-table :data="tableData" border style="width: 100%" v-loading="load_data">
			<el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
			<el-table-column prop="totalBalance" label="当前余额" align="center"></el-table-column>
			<el-table-column prop="currencyCode" label="币种" align="center"></el-table-column>
			<el-table-column prop="sellerId" label="卖家Id" align="center"></el-table-column>
			<el-table-column prop="pullDate" label="拉取日期" align="center"></el-table-column>
			<el-table-column label="操作" fixed="right" width="240" align="center">
				<template slot-scope="scope">
					<el-button type="primary" @click="selectHistory(scope.row)">查看详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page">
			<el-pagination style="margin-top: 16px; text-align:center;" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[100, 200, 300, 400]"
				:page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
		<el-dialog title="查看详情" :visible.sync="dialogVis" width="55%" top="2%">
			<el-table :data="infoList" border style="width: 100%" v-loading="load_data">
				<el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
				<el-table-column prop="balance" label="当前余额" align="center"></el-table-column>
				<el-table-column prop="currencyCode" label="币种" align="center"></el-table-column>
				<el-table-column prop="countryChinese" label="国家" align="center"></el-table-column>
				<el-table-column prop="updateTime" label="更新日期" align="center"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVis = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
	name: "Procurement_approval",
	data() {
		return {
			load_data: false,
			currentPage: 1,
			dialogVis: false,
			pagesize: 50,
			size: 100,
			total: 0,
			ruleForm: {
				sellerId: "", //审批状态
				pullDate: '' // 拉取日期
			},
			spList: [],
			infoList: [],
			tableData: [],
			defaultDate: new Date()
		};
	},
	mounted() { },
	created() {
		this.str = JSON.parse(localStorage.getItem("role"));
		this.searchSpList()
		this.search2()
	},
	methods: {
		formatDate(date) {
			const y = date.getFullYear();
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const d = String(date.getDate()).padStart(2, '0');
			return `${y}-${m}-${d}`;
		},
		selectHistory(val) {
			var obj = {
				companyId: this.str.company_id,
				sellerId: val.sellerId,
				pullDate: val.pullDate
			}
			ajaxPost(Baseurl + "sellerBalanceController/selectSellerBalanceList", obj).then(res => {
				if (res.data.code == 200) {
					this.infoList = res.data.data
					this.dialogVis = true
				}
			});
		},
		search2() {
			this.currentPage = 1
			if (this.ruleForm.pullDate != '' && this.ruleForm.pullDate != null) {
				this.ruleForm.pullDate = this.formatDate(this.ruleForm.pullDate);
			}
			this.search()
		},
		searchSpList() {
			var obj = {
				company_id: this.str.company_id
			}
			ajaxPost(Baseurl + "sellerController/selectSpSellerByCompanyId", obj).then(res => {
				if (res.data.code == 200) {
					this.spList = res.data.data
				}
			});
		},
		search() {
			this.load_data = true;
			var obj = {
				companyId: this.str.company_id,
				page: this.currentPage,
				size: this.size,
				sellerId: this.ruleForm.sellerId,
				pullDate: this.ruleForm.pullDate
			};
			ajaxPost(Baseurl + "sellerBalanceController/selectSellerBalances", obj).then(res => {
				if (res.data.code == 200) {
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.load_data = false;
				}
			});
		},
		resetFprm() {
			this.currentPage = 1
			this.ruleForm.sellerId = ""
			this.ruleForm.pullDate = ""
			this.search()
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.size = val;
			this.search()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.currentPage = val;
			this.search()
		}
	},
};
</script>

<style lang="scss" scoped>
/deep/ {
	.el-dialog__body {
		padding: 0px 20px;
	}

	.search .el-form-item__content {
		margin-left: 40px !important;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
}

.information {
	width: 98%;
	overflow: hidden;
}

.scope_img {
	width: 65px;
	height: 65px;

	img {
		width: 100%;
		height: 100%;
	}
}

.prduct_img {
	width: 500px;
	height: 500px;
}

.padding {
	padding: 25px 0;
}

.img {
	display: flex;
	align-items: center;
	justify-content: center;
}

.page {
	position: fixed;
	width: 85%;
	bottom: 0;
	z-index: 999;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
	line-height: 50px;
}

.el-table {
	margin-bottom: 55px;
	/* 根据需要调整，确保分页不遮挡表格内容 */
}
</style>
